import { parse as parseUserAgent } from "express-useragent";

export const useIsMobile = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return !!parseUserAgent(window.navigator.userAgent).isMobile;
};
